import {Component, Input, OnInit} from '@angular/core';
import {Router} from '@angular/router';

import {debounceTime} from 'rxjs/operators';
import {Subject} from 'rxjs';

import {EventService, PageRequest} from '../../../../core';
import {AuthUser, TokenService} from '../../../../core/auth';
import {Customer, CustomerResponse} from '../../../../core/models/';
import {CustomerService} from '../../../../core/services/';
import {SelectItem} from 'primeng/api';
import {BreadcrumbService} from '../../../../breadcrumb.service';


@Component({
  selector: 'app-customer-list',
  templateUrl: './customer-list.page.html'
})

export class CustomerListPage implements OnInit {
  @Input() query = new PageRequest();
  private searchTerms = new Subject<PageRequest>();
  customerResponse = new CustomerResponse();
  loading = true;
  authUser: AuthUser = this.token.whoAmI();

  statusOptions: SelectItem[];
  selectedStatus: string;

  constructor(
    private router: Router,
    private customerService: CustomerService,
    private eventService: EventService,
    private token: TokenService,
    private breadcrumbService: BreadcrumbService
  ) {
    this.breadcrumbService.setItems([
      {label: 'admin', routerLink: ['/admin', 'dashboard']},
      {label: 'customer'},
      {label: 'list'},
    ]);

    this.statusOptions = [
      {label: 'Status', value: 'EMPTY'},
      {label: 'Active', value: 'A'},
      {label: 'Inactive', value: 'I'},
    ];
    this.selectedStatus = this.statusOptions[0].value;
  }

  ngOnInit() {
    this.searchTerms.pipe(debounceTime(500)).subscribe(
      (query) => {
        this.getCustomer(query);
      }
    );
  }

  navigateToCreateNew() {
    this.router.navigate(['customer']);
  }

  search(query: PageRequest): void {
    this.searchTerms.next(query);
  }

  paginate(event) {
    this.query.page = (event.first / event.rows) + 1;

    this.query.sortField = event.sortField !== undefined ? event.sortField : 'name';
    this.query.sortDir = this.query.getSortDir(event.sortOrder);

    this.getCustomer(this.query);
  }

  getCustomer(query?: PageRequest): void {
    this.loading = true;
    this.query.status = this.selectedStatus;
    this.customerService.search(this.query)
      .subscribe(
        (data) => {
          this.customerResponse = data;
          delete (this.loading);
        },
        (error) => {
          delete (this.loading);
        }
      );
  }

  deleteCustomer(customer: Customer): void {
    this.customerService.delete(customer);
    this.reloadCustomers(2000);
  }


  private reloadCustomers(timeout: number): void {
    window.setTimeout(() => {
      this.getCustomer();
    }, timeout);
  }
}
